import { render, staticRenderFns } from "./ursLogin.vue?vue&type=template&id=1c5267fc&scoped=true"
import script from "./ursLogin.vue?vue&type=script&lang=js"
export * from "./ursLogin.vue?vue&type=script&lang=js"
import style0 from "./ursLogin.vue?vue&type=style&index=0&id=1c5267fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5267fc",
  null
  
)

export default component.exports